import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ChannelListingModel extends Model {
  @attr('string') externalId!: string;
  @attr('string') name!: string;

  @belongsTo('booking-dot-com-hotel-publication', {
    async: false,
    inverse: 'channelListing',
  })
  bookingDotComHotelPublication?: ModelRegistry['booking-dot-com-hotel-publication'];

  @belongsTo('channel-connection', { async: false, inverse: 'channelListings' })
  channelConnection!: ModelRegistry['channel-connection'];

  @belongsTo('property', { async: false, inverse: 'channelListings' })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'channel-listing': ChannelListingModel;
  }
}
